import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./newSidebar.css";

const DashboardIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <rect x="3" y="3" width="7" height="7" rx="1" />
    <rect x="14" y="3" width="7" height="7" rx="1" />
    <rect x="3" y="14" width="7" height="7" rx="1" />
    <rect x="14" y="14" width="7" height="7" rx="1" />
  </svg>
);

const DocumentsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
    <path d="M7.752.066a.5.5 0 0 1 .496 0l3.75 2.143a.5.5 0 0 1 .252.434v3.995l3.498 2A.5.5 0 0 1 16 9.07v4.286a.5.5 0 0 1-.252.434l-3.75 2.143a.5.5 0 0 1-.496 0l-3.502-2-3.502 2.001a.5.5 0 0 1-.496 0l-3.75-2.143A.5.5 0 0 1 0 13.357V9.071a.5.5 0 0 1 .252-.434L3.75 6.638V2.643a.5.5 0 0 1 .252-.434zM4.25 7.504 1.508 9.071l2.742 1.567 2.742-1.567zM7.5 9.933l-2.75 1.571v3.134l2.75-1.571zm1 3.134 2.75 1.571v-3.134L8.5 9.933zm.508-3.996 2.742 1.567 2.742-1.567-2.742-1.567zm2.242-2.433V3.504L8.5 5.076V8.21zM7.5 8.21V5.076L4.75 3.504v3.134zM5.258 2.643 8 4.21l2.742-1.567L8 1.076zM15 9.933l-2.75 1.571v3.134L15 13.067zM3.75 14.638v-3.134L1 9.933v3.134z" />
  </svg>
);

const ReportsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
    <path d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022zm2.004.45a7 7 0 0 0-.985-.299l.219-.976q.576.129 1.126.342zm1.37.71a7 7 0 0 0-.439-.27l.493-.87a8 8 0 0 1 .979.654l-.615.789a7 7 0 0 0-.418-.302zm1.834 1.79a7 7 0 0 0-.653-.796l.724-.69q.406.429.747.91zm.744 1.352a7 7 0 0 0-.214-.468l.893-.45a8 8 0 0 1 .45 1.088l-.95.313a7 7 0 0 0-.179-.483m.53 2.507a7 7 0 0 0-.1-1.025l.985-.17q.1.58.116 1.17zm-.131 1.538q.05-.254.081-.51l.993.123a8 8 0 0 1-.23 1.155l-.964-.267q.069-.247.12-.501m-.952 2.379q.276-.436.486-.908l.914.405q-.24.54-.555 1.038zm-.964 1.205q.183-.183.35-.378l.758.653a8 8 0 0 1-.401.432z" />
    <path d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0z" />
    <path d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5" />
  </svg>
);

const LogoutIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" y1="12" x2="9" y2="12" />
  </svg>
);

const SettingsIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <circle cx="12" cy="12" r="3" />
    <path d="M12 1v6m0 6v6m8.66-9l-5.2 3m-6.92 4L3.34 14M20.66 17l-5.2-3m-6.92-4L3.34 7" />
  </svg>
);

export const NewSidebareCommercial = () => {
  const CommercialId = localStorage.getItem("CommercialId");
  const CommercialName = localStorage.getItem("CommercialName");

  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth);
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => setIsCollapsed(!isCollapsed);
  const toggleMobileSidebar = () => setIsMobileOpen(!isMobileOpen);
  const closeMobileSidebar = () => setIsMobileOpen(false);

  const menuItems = [
    {
      paths: [`/commercials/${CommercialId}`],
      label: "Accueil",
      icon: DashboardIcon,
      exact: true,
    },
    {
      paths: [`/commercials/${CommercialId}/articles`],
      label: "Articles",
      icon: DocumentsIcon,
      exact: true,
    },
    {
      paths: [`/commercials/${CommercialId}/historique`],
      label: "Suivi",
      icon: ReportsIcon,
      exact: true,
    },
  ];

  const isMobile = screenWidth <= 768;

  useEffect(() => {
    const offset = isMobile ? "0px" : isCollapsed ? "80px" : "220px";
    document.body.classList.add("app-has-sidebar");
    document.documentElement.style.setProperty("--app-sidebar-offset", offset);

    return () => {
      document.body.classList.remove("app-has-sidebar");
      document.documentElement.style.removeProperty("--app-sidebar-offset");
    };
  }, [isMobile, isCollapsed]);

  return (
    <>
      {/* Mobile Menu Trigger */}
      {isMobile && (
        <button className="mobile-menu-trigger-nsb" onClick={toggleMobileSidebar}>
          <i className="bi bi-list" />
        </button>
      )}

      {/* Overlay for mobile */}
      {isMobile && (
        <div
          className={`sidebar-overlay-nsb ${isMobileOpen ? "active-nsb" : ""}`}
          onClick={closeMobileSidebar}
        />
      )}

      {/* Notification Button (top-right) */}
      <div className="notification-btn-wrapper-nsb">
        <NavLink to={`/commercials/${CommercialId}/notification`}>
          <button className="notification-btn-nsb">
            <i className="bi bi-bell" />
          </button>
        </NavLink>
      </div>

      {/* Sidebar */}
      <aside
        className={`sidebar-nsb ${isCollapsed ? "collapsed-nsb" : ""} ${
          isMobile && isMobileOpen ? "open-mobile-nsb" : ""
        }`}
      >
        <button className="toggle-sidebar-btn-nsb" onClick={toggleSidebar}>
          <i
            className={`bi ${
              isCollapsed ? "bi-chevron-right" : "bi-chevron-left"
            }`}
          />
        </button>

        <div className="sidebar-content-nsb">
          {/* User Profile */}
          <div className="user-profile-nsb">
            <div className="user-avatar-nsb">
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  background: "var(--gold-nsb)",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "18px",
                  fontWeight: "700",
                  color: "var(--ink-nsb)",
                }}
              >
                {CommercialName?.charAt(0)?.toUpperCase()}
              </div>
            </div>
            {!isCollapsed && (
              <div className="user-info-nsb">
                <h3>{CommercialName}</h3>
              </div>
            )}
          </div>

          {/* Navigation */}
          <nav className="sidebar-nav-nsb">
            {menuItems.map((item) => {
              let isActive = false;
              if (item.exact) {
                isActive = location.pathname === item.paths[0];
              } else {
                isActive = item.paths.some((path) =>
                  location.pathname.startsWith(path)
                );
              }

              return (
                <NavLink
                  key={item.label}
                  to={item.paths[0]}
                  className={`nav-item-nsb ${isActive ? "active-nsb" : ""}`}
                  title={isCollapsed ? item.label : ""}
                  onClick={isMobile ? closeMobileSidebar : undefined}
                >
                  {item.icon && <item.icon />}
                  <span>{item.label}</span>
                </NavLink>
              );
            })}
          </nav>

          {/* Bottom Section */}
          <div className="sidebar-bottom-nsb">
            <div className="bottom-actions-nsb">
              <NavLink
                to={`/commercials/${CommercialId}/paramétres`}
                className="action-btn-nsb"
                title={isCollapsed ? "Paramètres" : ""}
                onClick={isMobile ? closeMobileSidebar : undefined}
              >
                <SettingsIcon />
                <span>Paramètres</span>
              </NavLink>
              <NavLink
                to="/logout"
                className="logout-pro-btn"
                title={isCollapsed ? "Déconnecter" : ""}
                onClick={isMobile ? closeMobileSidebar : undefined}
              >
                <LogoutIcon />
                <span>Déconnecter</span>
              </NavLink>
            </div>
          </div>
        </div>
      </aside>
    </>
  );
};